import { Box } from "@chakra-ui/react";

import WithdrawalsData from "./WithdrawalsData";

export default function WithdrawalTransactionsCard() {
  return (
    <Box
      background="#fff"
      border="1px solid #e0e3e6"
      borderRadius="24px"
      padding={6}
      minH="272px"
      height="100%"
    >
      <WithdrawalsData />
    </Box>
  );
}
